import { Component, Input } from '@angular/core';
import emojiRegex from 'emoji-regex';
import { GameSettingsService } from '../../game-settings.service';

@Component({
  selector: 'emoji-confetti',
  templateUrl: './emoji-confetti.component.html',
  styleUrls: ['./emoji-confetti.component.scss']
})
export class EmojiConfettiComponent {

  @Input('index') index: number = 0;

  constructor(public gameSettingsService: GameSettingsService) { 
  }

  isValidEmoji(value: string): boolean {
    return emojiRegex().test(value);
  }

}
